/**
 * Global configuration for the application
 * 
 * Set `useLocalBackend` to `true` to use the local backend
 * Set to `false` to use the hosted backend
 */

// Set this to true to use local backend, false for hosted backend
export const useLocalBackend = false;

// API endpoints
const API_ENDPOINTS = {
  local: 'http://localhost:8000',  // Local development server
  hosted: 'https://admin.stage.mysenscare.com'  // Hosted production server
};

// Export the current API base URL
export const apiBaseUrl = useLocalBackend ? API_ENDPOINTS.local : API_ENDPOINTS.hosted;
